import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      loading: false,
      search: "",
      usuarios: [],
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui",
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Fecha Declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion",
        },
        {
          text: "Dirección",
          align: "center",
          sortable: true,
          value: "direccion",
        },
        {
          text: "Colaborador TIC",
          align: "center",
          sortable: true,
          value: "empleado",
        },
        {
          text: "Fecha de Creación",
          align: "center",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Fecha de Modificación",
          align: "center",
          sortable: true,
          value: "updated_at",
        },
      ],
    };
  },
  async created() {
    await this.getUsuarios();
  },
  methods: {

    exportarExcel() {
      let info = [];
      this.usuarios.forEach(element => {

        let data = {
          CUI: element.cui,
          NOMBRE: element.nombre,
          NIT: element.nit,
          DIA_DECLARACION: element.fecha_declaracion,
          DIRECCION: element.direccion,
          EMPLEADO: element.empleado,
          CREADO: element.created_at,
          ACTUALIZADO: element.updated_at
        }
        info.push(data);
      });
      console.log("info");
      console.log(info);
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'movimientos_usuarios'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async editItem(item) {
      this.loading = true;
      // if (item.empleado) {
      //   this.$toast.info("EL USUARIO YA HA SIDO ACTUALIZADO", "");
      // } else {
      try {
        let r =
          await this.$store.state.services.administradorService.updateEmpleados(
            item
          );
        if (r.status === 200) {
          await this.getUsuarios();
          this.$toast.success(
            "SE HA ACTUALIZADO EL USUARIO EXITOSAMENTE",
            "EXITO"
          );
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar actualizar el usuario",
            "ERROR"
          );
        }
        this.loading = false;
      } catch (error) {
        //console.log("llego error");
        //console.log(error);
        this.$toast.error(
          "Ocurrió un error al intentar actualizar el usuario: " + error,
          "ERROR"
        );
        this.loading = false;
      }
      // }
    },

    async getUsuarios() {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.getUsuarios();
          console.log(r);
        r.data.data.filter((x) => {
          x.nombre =
            (x.primer_nombre === null ? '': x.primer_nombre) +
            " " +
            (x.segundo_nombre === null ? '':x.segundo_nombre) +
            " " +
           ( x.primer_apellido === null ? '' : x.primer_apellido)+
            " " +
           ( x.segundo_apellido === null ? '' : x.segundo_apellido);
        });
        this.usuarios = r.data.data;
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los usuarios"
        );
        this.loading = false;
      }
    },
  },
};